import React from "react";
import styled from "styled-components";
import Label from "./Label/Label";

const LabelWrap = styled.div`
    margin-top: 20px;
`;

const WithLabel = ({ label, children, module = {} }) => {
    return (
        <LabelWrap>
            {module.labelPosition !== "inline" && (
                <Label module={module}>{label}</Label>
            )}
            {children}
        </LabelWrap>
    );
};
export default WithLabel;
